<template>
  <div id="overlay" :class="{ out: !visible }">
    <div class="ov-logo">
      <img
        :src="logoUrl"
        alt="ISBET"
        style="height:220px;object-fit:contain;"
      />
    </div>
    <div class="ov-spinner"></div>
    <p class="ov-txt">{{ message }}</p>
  </div>
</template>

<script setup lang="ts">
import { useLogo } from '@/composables/useLogo'

withDefaults(defineProps<{ visible: boolean; message?: string }>(), {
  message: 'Carregando conversas do Wootdash…',
})

const { logoUrl } = useLogo()
</script>
